export enum FileTypes {
  Unknown,
  Image,
  Document,
  Archive,
}

export enum ImageContextTypes {
  Gallery,
  Settings,
  Product,
}

export enum FileItemTypeEnum {
  Project = 1,
  Estimate,
  Contractor,
  Customer,
  Task,
  ProjectType,
  ArchivedFiles,
  Comment,
  Invoice
}
